import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function RequireAuth({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center text-ink-500" data-testid="auth-loading">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-brand border-t-transparent" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (!allowed.includes(user.role)) {
      // Redirect to role home
      if (user.role === "coach") return <Navigate to="/coach/dashboard" replace />;
      if (user.role === "parent") return <Navigate to="/parent/dashboard" replace />;
      if (user.role === "platform_admin") return <Navigate to="/admin/dashboard" replace />;
      return <Navigate to="/" replace />;
    }
  }
  return children;
}
